// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/kamper/:kampId\",\"regex\":\"^/kamper/([^/]+)$\",\"paramNames\":[\"kampId\"],\"hasOptionalPrefix\":false},{\"path\":\"/saker/:sakId\",\"regex\":\"^/saker/([^/]+)$\",\"paramNames\":[\"sakId\"],\"hasOptionalPrefix\":false},{\"path\":\"/delt/:token\",\"regex\":\"^/delt/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/kampdag/:kampId\",\"regex\":\"^/kampdag/([^/]+)$\",\"paramNames\":[\"kampId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/baner\"},{\"path\":\"/dashboard\"},{\"path\":\"/innstillinger\"},{\"path\":\"/kamper\"},{\"path\":\"/kontakter\"},{\"path\":\"/saker\"},{\"path\":\"/login\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://643f5f56f42dbc547727b8eeb9a9972f@o4511282514231296.ingest.de.sentry.io/4511282526683216",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
